import { usePaymentContext } from '@/context-state/PaymentContext.jsx'

export const planTiers = {
    free: 0,
    starter: 5,
    pro: 10,
    premium: 20,
    enterprise: 30,
}

export const useTierGuard = (requiredTier = 0) => {

    const { subscription } = usePaymentContext()

    const isTierQualified = subscription.tier >= requiredTier

    return isTierQualified

}